import { render, staticRenderFns } from "./PetInfo.vue?vue&type=template&id=1b7e088c&"
import script from "./PetInfo.vue?vue&type=script&lang=js&"
export * from "./PetInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports